import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { TabsStyle } from './Tabs.styles.js';
import { TabList } from './TabList.js';
import { TabsContext } from './TabsContext.js';
import { defaultProps } from './constants.js';
import { useTabsState } from './hooks.js';

const TabsContainer = forwardRef(({ alignment, children, color, iconPos, onTabSelect, sizing, tabListProps, variant, ...props }, ref) => {
    const [{ items, selected }, dispatch] = useTabsState();
    return (React.createElement("div", { ...props, ref: ref },
        React.createElement(TabsContext.Provider, { value: {
                dispatch,
                items,
                selected,
            } },
            React.createElement(TabList, { alignment: alignment, iconPos: iconPos, onTabSelect: onTabSelect, sizing: sizing, variant: variant, ...tabListProps, color: color }),
            children)));
});
TabsContainer.displayName = 'TabsContainer';
TabsContainer.defaultProps = defaultProps;
/**
 * `<Tabs>` is the main container for tabs and is expected to contain several
 * <Tab> components as children.
 *
 * @public
 */
const Tabs = styled(TabsContainer) `
    ${TabsStyle}
`;

export { Tabs };
//# sourceMappingURL=Tabs.js.map
